import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ProcessSSOLogin from "../components/ProcessSSOLogin";

function ProcessBack() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const ssoToken = params.get("ssotoken");
  const [count, setCount] = useState(5);

  console.log("ssotoken", ssoToken);

  useEffect(() => {
    if (count <= 0) return;
    const timer = setTimeout(() => setCount((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [count]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff",
        flexDirection: "column",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      {/* Redirect countdown text */}
      <p style={{ fontSize: "18px", color: "#555", marginBottom: "16px" }}>
        You'll Redirection with{" "}
        <strong style={{ color: "#e53935", fontWeight: 700 }}>
          {count} Seconds
        </strong>
      </p>

      {/* Illustration image */}
      <img
        src="/assets/images/loader-image.jpg"
        alt="Redirecting..."
        style={{ width: "480px", maxWidth: "90vw" }}
      />

      {/* Background process */}
      <ProcessSSOLogin token={ssoToken} />
    </div>
  );
}

export default ProcessBack;
